<!-- Header -->
<header>
  <div class="header-container">
    <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" />

    <nav>
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <!-- <a href="javascript:void(0)" class="login-signup-btn" (click)="login()">Login / Signup</a> -->
         <!-- Show avatar if logged in, else show Login/Signup -->
      <ng-container *ngIf="isLoggedIn; else loginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="router.navigate(['/consumer/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #loginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="login()">Login / Signup</a>
      </ng-template>
    </nav>

    <button class="mobile-menu-btn" (click)="toggleMobileMenu()">☰</button>
  </div>

  <div class="mobile-menu" [class.active]="mobileMenuOpen" id="mobileMenu">
    <div class="header-container">
      <div style="width: 100%;">
        <nav class="mobile-nav">
          <a href="https://lex-z.ai/">Find Lawyers</a>
          <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
          <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
          <a href="https://lex-z.ai/products/">Products</a>
          <a href="https://lex-z.ai/blogs/">Resources</a>
          <ng-container *ngIf="isLoggedIn; else mobileLoginBtn">
            <a href="javascript:void(0)" class="my-appointments-btn"
               (click)="mobileMenuOpen = false; router.navigate(['/consumer/appointments'])">
              My Appointments
            </a>
          </ng-container>
          <ng-template #mobileLoginBtn>
            <a href="javascript:void(0)" class="login-signup-btn"
               (click)="mobileMenuOpen = false; login()">Login / Signup</a>
          </ng-template>
        </nav>
      </div>
    </div>
  </div>
</header>
<div class="upload-overlay" *ngIf="isLoading">
  <div class="logo-spinner">
    <img src="assets/logo.svg" alt="Loading..." />
  </div>
</div>
<div class="page-content">
<div class="page-container">

  <!-- ═══════════════════════════════════════════════════════════
       ERROR STATE
       ═══════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!isLoading && loadingError">
    <div class="error-container">
      <div class="error-icon">⚠️</div>
      <h2 class="error-title">Unable to Load Details</h2>
      <p class="error-message">{{ loadingError }}</p>
      <button class="error-retry-btn" (click)="retryLoadingProfile()">
        <span class="retry-icon">↻</span> Retry
      </button>
      <a href="/" class="error-back-link">← Back to Lawyers</a>
    </div>
  </ng-container>

  <!-- ═══════════════════════════════════════════════════════════
       CONTENT STATE - Normal Page (2-column layout)
       ═══════════════════════════════════════════════════════════ -->

   
  <ng-container class='page-content' *ngIf="!isLoading && !loadingError && lawyer">

    <div class="two-col-layout">

      <!-- ── LEFT COLUMN: existing content ── -->
      <div class="main-col">

        <!-- Doctor Profile -->
        <div class="profile-card">
            <div class="profile-pic-container">
                <ng-container *ngIf="profileImg && profileImg !== ''; else noImg">
                    <img [src]="profileImg" [alt]="lawyer.profile.name + ' Profile Picture'" class="profile-pic" (error)="profileImg = null" loading="lazy" />
                </ng-container>

                <ng-template #noImg>
                    <div class="profile-placeholder">
                        {{ getInitial() }}
                    </div>
                </ng-template>
            </div>

            <div class="profile-details">
                <h2>{{lawyer.profile.name}}</h2>
                <!-- <p class="degree">{{lawyer.profile.gender}}</p> -->
                <p class="degree2"><i class="bi bi-geo-alt"></i> {{lawyer.profile.address.city_town}}{{ lawyer.profile.address.state ? ', ' + lawyer.profile.address.state : '' }}</p>

                <div class="badges">
                  <span class="verified">
                    {{ getVisibleSpecializations(lawyer.profile.practice_areas) }}
                  </span>
                </div>
            </div>
        </div>

        <!-- Profile Tabs -->
      <div class="profile-tabs-container">
        <div class="profile-tabs">
          <button type="button" class="profile-tab"
                  [class.active]="activeProfileTab === 'overview'"
                  (click)="setProfileTab('overview')">
            Overview
          </button>
          <button type="button" class="profile-tab"
                  [class.active]="activeProfileTab === 'slots'"
                  (click)="setProfileTab('slots')">
            Available Slots
          </button>
        </div>

        <!-- ═══════════════ TAB: OVERVIEW ═══════════════ -->
        <div class="overview-panel" *ngIf="activeProfileTab === 'overview'">
          <div class="overview-grid">

            <!-- About the Lawyer -->
            <div class="overview-block">
              <h4 class="overview-block-title"><i class="bi bi-person"></i> About the Lawyer</h4>
              <p class="overview-text" [class.clamped]="!bioExpanded">{{ lawyer.profile.bio }}</p>
              <a *ngIf="lawyer.profile.bio && lawyer.profile.bio.length > 160"
                 href="javascript:void(0)" class="read-more-link"
                 (click)="bioExpanded = !bioExpanded">
                {{ bioExpanded ? 'Read less' : 'Read more' }}
              </a>
            </div>

            <!-- Cases Handled -->
            <div class="overview-block">
              <h4 class="overview-block-title"><i class="bi bi-briefcase"></i> Cases Handled</h4>
              <ul class="cases-handled-list" *ngIf="casesHandledItems.length; else noCases">
                <li class="cases-handled-item" *ngFor="let item of casesHandledItems; let i = index">
                  <span class="case-bullet"></span>
                  <div class="case-content">
                    <div class="case-title" *ngIf="item.title">{{ item.title }}</div>
                    <p class="overview-text" [class.clamped]="!casesExpandedMap[i]">{{ item.description }}</p>
                    <a *ngIf="item.description.length > 160"
                       href="javascript:void(0)" class="read-more-link"
                       (click)="toggleCaseExpanded(i)">
                      {{ casesExpandedMap[i] ? 'Read less' : 'Read more' }}
                    </a>
                  </div>
                </li>
              </ul>
              <ng-template #noCases>
                <p class="overview-empty">No cases handled information added yet.</p>
              </ng-template>
            </div>

          </div><!-- /overview-grid -->

          <!-- Practicing At — full-width row below About/Cases Handled -->
          <div class="overview-block overview-block-full" *ngIf="lawyer.profile.practice_at?.length">
            <h4 class="overview-block-title"><i class="bi bi-bank"></i> Practicing At</h4>
            <div class="practicing-at-list">
              <div class="practicing-at-item" *ngFor="let court of lawyer.profile.practice_at">
                <span class="court-name">{{ formatCourtName(court.court_name) }}</span>
                <span class="court-location">{{ formatCourtLocation(court) }}</span>
              </div>
            </div>
          </div>

        </div><!-- /overview-panel -->

        <!-- ═══════════════ TAB: AVAILABLE SLOTS ═══════════════ -->
        <div class="appointment-card" *ngIf="activeProfileTab === 'slots'">
            <div class="slot-header-row">
              <h3>Pick a Time Slot</h3>
              <span class="slot-fee">
                <span class="slot-fee-label">Consultation Fee</span>
                <span class="slot-fee-amount">{{lawyer.profile.consultation_fee?.symbol || '₹'}}{{lawyer.profile.consultation_fee?.amount}}</span>
              </span>
            </div>

            <!-- Date Tabs -->
            <div class="date-tabs-wrapper">
              <button class="date-nav-btn date-nav-prev"
                      (click)="scrollDateTabs(-1)"
                      [class.hidden]="!canScrollLeft"
                      aria-label="Previous dates">
                <i class="bi bi-chevron-left"></i>
              </button>

              <div class="date-tabs" #dateTabsScroll (scroll)="onDateTabsScroll()">
                <div class="date"
                    *ngFor="let d of dateTabs"
                    [class.active]="selectedDateKey === d.date"
                    (click)="filterByExactDate(d.date)">
                  {{ d.label }}
                  <span>{{ d.available_slots }} Slots Available</span>
                </div>
              </div>

              <button class="date-nav-btn date-nav-next"
                      (click)="scrollDateTabs(1)"
                      [class.hidden]="!canScrollRight"
                      aria-label="Next dates">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>

            <!-- Slots -->
            <div class="slots-container">

              <div *ngFor="let day of filteredSlots" class="day-block">

                <!-- <h3 class="day-title">
                  {{ day.day_label }}
                  <small>({{ getAvailableCount(day.morning) 
                            + getAvailableCount(day.afternoon) 
                            + getAvailableCount(day.evening) 
                            + getAvailableCount(day.night) }} slots)</small>
                </h3> -->

                <!-- Morning -->
                <div class="slot-section" *ngIf="day.morning?.length">
                  <h4>Morning <small>({{ getAvailableCount(day.morning) }} slots)</small></h4>
                  <div class="slots">
                    <button *ngFor="let s of day.morning"
                            [disabled]="!s.available"
                            (click)="checkout(day, s)">
                      {{ s.start_time }}
                    </button>
                  </div>
                </div>

                <!-- Afternoon -->
                <div class="slot-section" *ngIf="day.afternoon?.length">
                  <h4>Afternoon <small>({{ getAvailableCount(day.afternoon) }} slots)</small></h4>
                  <div class="slots">
                    <button *ngFor="let s of day.afternoon"
                            [disabled]="!s.available"
                            (click)="checkout(day, s)">
                      {{ s.start_time }}
                    </button>
                  </div>
                </div>

                <!-- Evening -->
                <div class="slot-section" *ngIf="day.evening?.length">
                  <h4>Evening <small>({{ getAvailableCount(day.evening) }} slots)</small></h4>
                  <div class="slots">
                    <button *ngFor="let s of day.evening"
                            [disabled]="!s.available"
                            (click)="checkout(day, s)">
                      {{ s.start_time }}
                    </button>
                  </div>
                </div>

                <!-- Night -->
                <div class="slot-section" *ngIf="day.night?.length">
                  <h4>Night <small>({{ getAvailableCount(day.night) }} slots)</small></h4>
                  <div class="slots">
                    <button *ngFor="let s of day.night"
                            [disabled]="!s.available"
                            (click)="checkout(day, s)">
                      {{ s.start_time }}
                    </button>
                  </div>
                </div>

              </div>

            </div>
        </div>

      </div><!-- /main-col -->
      </div>

      <!-- ── RIGHT COLUMN: info cards ── -->
      <div class="side-col">

        <!-- Why choose Lex-Z? -->
        <div class="info-card">
          <h4 class="info-card-title">Why choose Lex-Z?
          </h4>
          <ul class="info-card-list">
            <li>
              <span class="info-item-icon"><i class="bi bi-person-check"></i></span>
              <div>
                <strong>Verified &amp; trusted professionals</strong>
                <p>All lawyers are verified by our team</p>
              </div>
            </li>
            <li>
              <span class="info-item-icon"><i class="bi bi-shield-lock"></i></span>
              <div>
                <strong>Secure &amp; confidential</strong>
                <p>Your information is safe with us</p>
              </div>
            </li>
            <li>
              <span class="info-item-icon"><i class="bi bi-calendar-check"></i></span>
              <div>
                <strong>Hassle-free booking</strong>
                <p>Book, pay and consult with ease</p>
              </div>
            </li>
          </ul>
        </div>

        <!-- What happens next? -->
        <div class="info-card">
          <h4 class="info-card-title"> What happens next?
          </h4>
          <ol class="info-steps-list">
            <li>
              <span class="step-num">1</span>
              <div>
                <strong>You've viewed the lawyer's profile</strong>
                <p>Shortlisted and explored their background</p>
              </div>
            </li>
            <li>
              <span class="step-num step-num--active">2</span>
              <div>
                <strong>Choose a time &amp; book appointment</strong>
                <p>Select a slot that suits your schedule</p>
              </div>
            </li>
            <li>
              <span class="step-num">3</span>
              <div>
                <strong>Consult &amp; get legal help</strong>
                <p>Connect and discuss your case securely</p>
              </div>
            </li>
          </ol>
        </div>

        <!-- Visit Help Center -->
        <div class="info-card help-card">
          <div class="help-card-body">
            <div class="help-text">
              <strong>Have questions before booking?</strong>
              <p>Explore our resources or reach out to our support team.</p>
            </div>
           <a class="help-btn" title="Contact Support" href="#" onclick="window.open('https://mail.google.com/mail/?view=cm&fs=1&to=support@lexiz.ai&su=Support%20Request', '_blank'); return false;">
            Visit Help Center &rarr;
            </a>
          </div>
        </div>

      </div><!-- /side-col -->

    </div><!-- /two-col-layout -->

  </ng-container>

</div>


<!-- ═══════════════════════════════════════════════════════════
     LOGIN / REGISTER MODAL POPUP
     ═══════════════════════════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="showLoginModal" (click)="closeModalOnBackdrop($event)">
  <div class="modal-panel" role="dialog" aria-modal="true" aria-label="Login to continue">

    <!-- Close Button -->
    <button class="modal-close" (click)="closeLoginModal()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <!-- ═══════════════ VIEW: LOGIN / REGISTER ═══════════════ -->
    <ng-container *ngIf="modalView === 'login'">

      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">
          <ng-container *ngIf="otpSent">Enter OTP</ng-container>
          <ng-container *ngIf="!otpSent">
            {{ isRegisterMode ? 'Create your account' : 'Login into your account' }}
          </ng-container>
        </h2>
      </div>

      <div class="otp-sent-banner" *ngIf="otpSent && isRegisterMode">
        {{ otpSentMessage }}
      </div>
      <div class="otp-sent-banner" *ngIf="otpSent && !isRegisterMode">
        OTP sent to your {{ loginType === 'email' ? 'email' : 'mobile number' }}
      </div>

      <form [formGroup]="isRegisterMode ? registerForm : loginForm" class="modal-form" (ngSubmit)="isRegisterMode ? onRegisterButtonClicked() : onLoginButtonClicked()">

        <div *ngIf="!otpSent">

          <!-- REGISTER MODE: Name Fields -->
          <ng-container *ngIf="isRegisterMode">
            <div class="name-fields" style="display: flex; gap: 15px; margin-bottom: 15px;">
              <div class="modal-field" style="flex: 1; margin-bottom: 0;">
                <label>First Name</label>
                <input type="text" formControlName="firstName" placeholder="Enter your first name"
                  (input)="restricttextSpace($event)"
                  [class.field-error]="submitted && registerForm.get('firstName')?.errors">
                <div class="field-error-msg" *ngIf="submitted && registerForm.get('firstName')?.errors">
                  <span *ngIf="registerForm.get('firstName')?.errors?.['required']">First Name is required</span>
                </div>
              </div>
              <div class="modal-field" style="flex: 1; margin-bottom: 0;">
                <label>Last Name</label>
                <input type="text" formControlName="lastName" placeholder="Enter your last name"
                  (input)="restricttextSpace($event)"
                  [class.field-error]="submitted && registerForm.get('lastName')?.errors">
                <div class="field-error-msg" *ngIf="submitted && registerForm.get('lastName')?.errors">
                  <span *ngIf="registerForm.get('lastName')?.errors?.['required']">Last Name is required</span>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- REGISTER MODE: Email Field -->
          <div class="modal-field" *ngIf="isRegisterMode">
            <label>Email Address</label>
            <input
              type="email"
              formControlName="email"
              placeholder="Enter your email address"
              (input)="restricttextSpace($event)"
              [class.field-error]="submitted && registerForm.get('email')?.errors"
              autocomplete="off">
            <div class="field-error-msg" *ngIf="submitted && registerForm.get('email')?.errors">
              <span *ngIf="registerForm.get('email')?.errors?.['required']">Email address is required</span>
              <span *ngIf="registerForm.get('email')?.errors?.['invalidEmail']">Please enter a valid email address</span>
            </div>
          </div>

          <!-- REGISTER MODE: Mobile Number Field -->
          <div class="modal-field" *ngIf="isRegisterMode">
            <label>Mobile Number</label>
            <input
              type="text"
              inputmode="numeric"
              formControlName="mobile"
              placeholder="Enter your mobile number"
              (input)="onMobileInput($event)"
              [class.field-error]="submitted && registerForm.get('mobile')?.errors"
              autocomplete="off"
              maxlength="10">
            <div class="field-error-msg" *ngIf="submitted && registerForm.get('mobile')?.errors">
              <span *ngIf="registerForm.get('mobile')?.errors?.['required']">Mobile number is required</span>
              <span *ngIf="registerForm.get('mobile')?.errors?.['invalidMobile']">Please enter a valid phone number</span>
            </div>
          </div>

          <!-- LOGIN MODE: Email / Mobile -->
          <div class="modal-field" *ngIf="!isRegisterMode">
            <label>{{ useOTP ? 'Email or Mobile Number' : 'Email Address' }}</label>
            <input
              type="text"
              formControlName="emailOrMobile"
              [placeholder]="useOTP ? 'Enter your email or mobile number' : 'Enter your email'"
              (input)="restricttextSpace($event)"
              [class.field-error]="submitted && f['emailOrMobile'].errors"
              autocomplete="username">
            <div class="field-error-msg" *ngIf="submitted && f['emailOrMobile'].errors">
              <span *ngIf="f['emailOrMobile'].errors?.['required']">
                {{ useOTP ? 'Email or mobile number is required' : 'Email is required' }}
              </span>
              <span *ngIf="f['emailOrMobile'].errors?.['invalidEmailOrMobile'] && useOTP">Please enter a valid email or mobile</span>
            </div>
          </div>

          <!-- Password Field (Login mode, password method) -->
          <div class="modal-field password-field" *ngIf="!useOTP && !isRegisterMode">
            <label>Password</label>
            <div class="password-input-wrap">
              <input
                [type]="hidePassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="Enter your password"
                autocomplete="current-password"
                [class.field-error]="submitted && f['password'].errors">
              <button type="button" class="toggle-password" (click)="hidePassword = !hidePassword">
                <i class="bi" [class.bi-eye]="hidePassword" [class.bi-eye-slash]="!hidePassword"></i>
              </button>
            </div>
            <div class="field-error-msg" *ngIf="submitted && f['password'].errors">
              <span *ngIf="f['password'].errors?.['required']">Password is required</span>
            </div>
          </div>
        </div>

        <!-- Toggle OTP / Password + Remember Me -->
        <div class="modal-toggle-row" *ngIf="!otpSent">
          <label class="remember-me" *ngIf="!useOTP && !isRegisterMode">
            <input type="checkbox" formControlName="rememberMe">
            <span>Remember me</span>
          </label>
          <a href="javascript:void(0)"
            class="toggle-login-method"
            *ngIf="!isRegisterMode"
            (click)="toggleLoginMethod()">
            {{ useOTP ? 'Use Password Instead' : 'Use OTP Instead' }}
          </a>
        </div>

        <!-- Login OTP Block -->
        <div class="modal-field otp-field" *ngIf="useOTP && otpSent && !isRegisterMode">
          <label>Enter 6-digit OTP</label>
          <div class="otp-boxes">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)"
              (paste)="onOtpPaste($event)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 4)" (keydown)="onOtpKeyDown($event, 4)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 5)" (keydown)="onOtpKeyDown($event, 5)" autocomplete="off">
          </div>
          <div class="field-error-msg" *ngIf="submitted && f['otp'].errors">
            <span *ngIf="f['otp'].errors?.['required']">OTP is required</span>
            <span *ngIf="f['otp'].errors?.['pattern']">OTP must be 6 digits</span>
          </div>
        </div>

        <!-- Register OTP Block -->
        <div class="modal-field otp-field" *ngIf="isRegisterMode && otpSent">
          <label>Enter OTP</label>
          <div class="otp-boxes">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)"
              (paste)="onOtpPaste($event)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 4)" (keydown)="onOtpKeyDown($event, 4)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 5)" (keydown)="onOtpKeyDown($event, 5)" autocomplete="off">
          </div>
          <div class="field-error-msg" *ngIf="submitted && registerForm.get('otp')?.errors">
            <span *ngIf="registerForm.get('otp')?.errors?.['required']">OTP is required</span>
          </div>
        </div>

        <!-- Actions Row (resend only) -->
        <div class="modal-actions-row">
          <div class="resend-container" *ngIf="otpSent">
            <span *ngIf="!canResend" class="resend-timer">Resend in {{ resendTimer }}s</span>
            <a *ngIf="canResend" href="javascript:void(0)" class="resend-otp" (click)="resendOTP()">Resend OTP</a>
          </div>
        </div>

        <!-- Primary Button -->
        <button type="submit" class="modal-login-btn">
          {{ otpSent ? 'Verify OTP' : (useOTP ? 'Send OTP' : 'Log In') }}
        </button>

        <!-- Cancel when OTP sent -->
        <button *ngIf="otpSent" type="button" class="modal-cancel-btn" (click)="cancelOTP()">
          Go Back
        </button>

        <!-- Forgot Password link — shown only in password mode before OTP stage -->
        <div *ngIf="!useOTP && !otpSent && !isRegisterMode" class="modal-forgot-row">
          <a href="javascript:void(0)" class="modal-forgot-link" (click)="goToForgotPassword()">Forgot Password?</a>
        </div>

        <!-- Toggle Login/Register -->
        <div class="modal-footer-toggle" *ngIf="!otpSent" style="text-align: center; margin-top: 15px; font-size: 14px; color: #666;">
          <ng-container *ngIf="!isRegisterMode">
            Don't have an account ? <a href="javascript:void(0)" class="register-link" (click)="isRegisterMode = true; showConfirmDialog = false; isLoginRedirectFlow = false; otpSentMessage = ''" style="color: #007bff; font-weight: 500;">Register Here</a>
          </ng-container>
          <ng-container *ngIf="isRegisterMode">
            Already have an account ? <a href="javascript:void(0)" class="register-link" (click)="isRegisterMode = false; showConfirmDialog = false; isLoginRedirectFlow = false; otpSentMessage = ''" style="color: #007bff; font-weight: 500;">Log In</a>
          </ng-container>
        </div>

      </form>
    </ng-container>

    <!-- ═══════════════ VIEW: FORGOT PASSWORD ═══════════════ -->
    <ng-container *ngIf="modalView === 'forgot'">
      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">Forgot Password</h2>
      </div>

      <form [formGroup]="forgotPasswordForm" class="modal-form" (ngSubmit)="onForgotPasswordSubmit()">
        <p class="modal-info-text">Don't worry! Please enter the email address associated with your account.</p>

        <div class="modal-field">
          <label>Email Address</label>
          <input type="email" formControlName="email"
            placeholder="Enter your email address"
            (input)="restricttextSpace($event)"
            autocomplete="email"
            [class.field-error]="forgotSubmitted && forgotPasswordForm.get('email')?.errors">
          <div class="field-error-msg" *ngIf="forgotSubmitted && forgotPasswordForm.get('email')?.errors">
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">Email is required</span>
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
          </div>
        </div>

        <button type="submit" class="modal-login-btn">Send Reset Token</button>

        <button type="button" class="modal-cancel-btn" (click)="modalView = 'login'">
          Back to Login
        </button>
      </form>
    </ng-container>

    <!-- ═══════════════ VIEW: RESET PASSWORD ═══════════════ -->
    <ng-container *ngIf="modalView === 'reset'">
      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">Reset Password</h2>
      </div>

      <form [formGroup]="resetPasswordForm" class="modal-form" (ngSubmit)="onResetPasswordSubmit()">
        <p class="modal-info-text">
          A password reset token was sent to <strong>{{ resetMail }}</strong>. Enter it below along with your new password.
        </p>

        <!-- Token -->
        <div class="modal-field">
          <label>Reset Token</label>
          <input type="text" formControlName="token"
            placeholder="Enter the token from your email"
            (input)="restricttextSpace($event)"
            autocomplete="off"
            [class.field-error]="resetSubmitted && rf['token'].errors">
          <div class="field-error-msg" *ngIf="resetSubmitted && rf['token'].errors">
            <span *ngIf="rf['token'].errors?.['required']">Token is required</span>
          </div>
        </div>

        <!-- New Password -->
        <div class="modal-field password-field">
          <label>New Password</label>
          <div class="password-input-wrap">
            <input
              [type]="hideResetPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Enter new password"
              autocomplete="new-password"
              [class.field-error]="resetSubmitted && rf['password'].errors">
            <button type="button" class="toggle-password" (click)="hideResetPassword = !hideResetPassword">
              <i class="bi" [class.bi-eye]="hideResetPassword" [class.bi-eye-slash]="!hideResetPassword"></i>
            </button>
          </div>
          <div class="field-error-msg" *ngIf="resetSubmitted && rf['password'].errors">
            <span *ngIf="rf['password'].errors?.['required']">Password is required</span>
            <span *ngIf="rf['password'].errors?.['minlength']">Password must be at least 8 characters</span>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="modal-field password-field">
          <label>Confirm Password</label>
          <div class="password-input-wrap">
            <input
              [type]="hideConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              placeholder="Confirm new password"
              autocomplete="new-password"
              [class.field-error]="resetSubmitted && (rf['confirmPassword'].errors || resetPasswordForm.errors?.['notSame'])">
            <button type="button" class="toggle-password" (click)="hideConfirmPassword = !hideConfirmPassword">
              <i class="bi" [class.bi-eye]="hideConfirmPassword" [class.bi-eye-slash]="!hideConfirmPassword"></i>
            </button>
          </div>
          <div class="field-error-msg" *ngIf="resetSubmitted && resetPasswordForm.errors?.['notSame']">
            <span>Passwords do not match</span>
          </div>
        </div>

        <div class="modal-resend-row">
          Didn't receive the token?
          <a href="javascript:void(0)" class="resend-otp" (click)="resendResetToken()">Resend Token</a>
        </div>

        <button type="submit" class="modal-login-btn">Update Password</button>

        <button type="button" class="modal-cancel-btn" (click)="modalView = 'forgot'">Back</button>
      </form>
    </ng-container>

  </div>
</div>

<!-- ========== Register Confirmation Dialog ========== -->
<div class="register-confirm-overlay" *ngIf="showConfirmDialog" (click)="$event.stopPropagation()">
  <div class="register-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="registerConfirmDialogTitle">
    <h3 class="register-confirm-title" id="registerConfirmDialogTitle">Confirm Details</h3>
    <p class="register-confirm-message">
      Please confirm your email address <strong>{{ confirmEmail }}</strong> and phone number <strong>{{ confirmPhone }}</strong>.
    </p>
    <div class="register-confirm-actions">
      <button type="button" class="register-confirm-btn-secondary" (click)="onRegisterConfirmCancel()">
        No, Edit
      </button>
      <button type="button" class="register-confirm-btn-primary" (click)="onRegisterConfirmProceed()">
        Yes, Continue
      </button>
    </div>
  </div>
</div>


<!-- Footer -->
<footer *ngIf="!isLoading">
  <div class="footer-container">
    <div class="footer-bottom">
      <a  alt="terms of service"
            href="https://digicoffer.com/digicoffer_terms.pdf">Terms of Service</a>
      <span>|</span>
      <a alt="privacy policy" href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policy</a>
      <span>|</span>
      <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookie Policy</a>
    </div>
    <div class="footer-credit">
      © {{ currentYear }} Lex-Z. All rights reserved.
    </div>
  </div>
</footer>